import isEmail from 'is-email';
import { define } from 'superstruct';

import { withMessage } from './withMessage';

/**
 * Ensure that a value is a valid email address.
 */
export const email = ({ allowEmpty = false } = {}) =>
	withMessage(
		define<string>('email', (value) => {
			if (typeof value !== 'string') {
				throw new TypeError('Email must be a string');
			}

			if (allowEmpty && value === '') {
				return true;
			}

			return isEmail(value);
		}),
		'validations:Invalid Email'
	);
